import {
  ChangeDetectionStrategy,
  Component,
  input,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicProductDataSourceService } from '../../services/public-product-data-source.service';
import {
  Icon,
  SlimButtonTheme,
  SpinnerFilledComponent,
  WithLoadingPipe,
} from '@web/shared/ui';
import { Observable } from 'rxjs';
import { SafeHtmlPipe } from '@web/common';
import { PublicProductCompositePaymentPeriodLabelPipe } from '../../pipes/public-product-composite-payment-period.pipe';
import { PublicProductCompositePaymentPeriod } from '../../enums/public-product-composite-payment-period';
import { PublicProductCompositeCollectionItem } from '../../models/public-product-composite-collection-item';
import { PublicCartAddButtonComponent } from '@web/shared/module/shop';

@Component({
  selector: 'app-public-order-box-tiles',
  imports: [
    CommonModule,
    PublicProductCompositePaymentPeriodLabelPipe,
    PublicCartAddButtonComponent,
    SafeHtmlPipe,
    SpinnerFilledComponent,
    WithLoadingPipe,
  ],
  templateUrl: './public-order-box-tiles.component.html',
  styleUrl: './public-order-box-tiles.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicOrderBoxTilesComponent {
  private readonly productDataSource = inject(PublicProductDataSourceService);

  public readonly styleClass = input<string>();

  protected readonly products$ = this.productsDataSource();

  protected readonly Icon = Icon;
  protected readonly PublicProductCompositePaymentPeriod =
    PublicProductCompositePaymentPeriod;

  protected isPaymentPeriodOnce(
    product: PublicProductCompositeCollectionItem,
  ): boolean {
    return product.paymentPeriod === PublicProductCompositePaymentPeriod.Once;
  }

  protected isPaymentPeriodPerMonth(
    product: PublicProductCompositeCollectionItem,
  ): boolean {
    return (
      product.paymentPeriod === PublicProductCompositePaymentPeriod.PerMonth
    );
  }

  protected isPaymentPeriodMonthly(
    product: PublicProductCompositeCollectionItem,
  ): boolean {
    return (
      product.paymentPeriod === PublicProductCompositePaymentPeriod.Monthly
    );
  }

  protected themeTypeByPaymentPeriod(
    product: PublicProductCompositeCollectionItem,
  ): SlimButtonTheme {
    switch (true) {
      case this.isPaymentPeriodPerMonth(product):
        return 'primary';

      case this.isPaymentPeriodOnce(product):
        return 'primary';

      case this.isPaymentPeriodMonthly(product):
        return 'primary';

      default:
        return 'dark';
    }
  }

  private productsDataSource(): Observable<
    PublicProductCompositeCollectionItem[]
  > {
    return this.productDataSource.fetchCompositeCollection();
  }
}
